<template>
  <div
    v-if="
      $formData.policyDetails.policyHolderInsured ||
        (!$formData.policyDetails.policyHolderInsured && $formData.familyMembers.length > 1)
    "
    class="form-group"
  >
    <h4 class="text-header form-section__title">
      <span
        v-for="(item, index) in $root.t('step3.physicianDetails')"
        :key="index"
      >
        {{ item }} <br>
      </span>
    </h4>
    <div
      v-if="!$formData.policyDetails.policyHolderInsured"
      class=""
    >
      <span
        v-for="(item, index) in $root.t('step3.policyNotInsuredPhysician')"
        :key="index"
      >
        {{ item }} <br>
      </span>
    </div>
    <div v-else>
      <p
        id="physical-desc"
        class="form-section__description"
      >
        <span
          v-for="(item, index) in $root.t('step3.physicianDesc')"
          :key="index"
        >
          {{ item }} <br>
        </span>
      </p>
      <PhysicalDetailsForm
        :form-data="form"
        :aria-label="'physical-desc'"
      />
    </div>
  </div>
</template>
<script>
import PhysicalDetailsForm from './Form/PhysicalDetailsForm.vue'

export default {
  name: 'PhysicianDetails',
  components: {
    PhysicalDetailsForm,
  },
  data() {
    return {
      // isExistingHealthInsurancePolicies: false,
      coverEndDate: null,
      providerCompanyName: '',
      form: this.$formData.policyHolder.additionalDetails.physicianDetails,
    }
  },
  methods: {
    changeInsuranceProvider(status) {
      if (status) {
        this.form.insuranceProvider = {
          coverEndDate: null,
          providerCompanyName: '',
        }
      } else {
        this.form.insuranceProvider = null
      }
    },
  },
}
</script>
